import styled from 'styled-components';

export const Container = styled.div`
  .showMore {
    margin-bottom: 10px;
  }

  div.head {
    display: flex;
    align-items: baseline;
    @media (max-width: 720px) {
      display: block;
    }

    .h1 {
      font-size: 35px;
      margin: 0 36px 10px 0;
    }
    span {
      font-size: 13px;
      margin-right: 28px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  div.neck {
    display: flex;
    text-align: center;
    align-items: center;
  }
  .showMore {
    width: 200px;
  }

  div.newsContainer {
    margin: 0 20px 0 20px;

    @media (max-width: 769px) {
      margin: 0;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  max-width: 100vw;
  padding: 15px;

  .Left {
    width: 66%;
    align-self: center;
    @media (max-width: 769px) {
      width: 100%;
    }
    .row {
      height: 350px;
      width: 100%;

      @media (max-width: 1040px) {
        width: 80%;
      }
      @media (max-width: 720px) {
        width: 100%;
      }
    }
  }

  .Right {
    display: flex;
    flex-direction: column;
    align-self: center;

    width: 33%;
    height: 100%;

    margin-left: 20px;

    @media (max-width: 769px) {
      display: none;
    }

    h2 {
      padding: 0 0 10px;
      border-bottom: solid;
      font-size: 18px;
      cursor: pointer;
    }
    div {
      .row {
        height: 80px;
        width: 100%;
        margin-bottom: 5px;

        @media (max-width: 1040px) {
          width: 80%;
        }
      }
    }
  }
`;

export const MoreNews = styled.div`
  margin: 10px 0 0 20px;

  .conteinerNews {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-right: 20px;
    gap: 10px;
  }

  .newsItem {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid;
    align-items: center;
    padding: 20px 0;

    @media (max-width: 500px) {
      flex-direction: column;
    }
    .leftItem {
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 10px;
      h3 {
        font-size: 12px;
        cursor: pointer;
      }
      h2 {
        font-size: 20px;
        cursor: pointer;
      }

      span {
        font-size: 14px;
        margin-bottom: 10px;
        cursor: pointer;
      }

      @media (max-width: 500px) {
        order: 2;
        width: 100%;
      }
    }
    img {
      height: 150px;
      width: 270px;
      object-fit: cover;
      border-radius: 22px;
      border: 1px solid;
      margin-bottom: 10px;
      cursor: pointer;

      @media (max-width: 500px) {
        order: 1;
        width: 100%;
        height: 200px;
      }
      @media (max-width: 310px) {
        width: 100%;
      }
    }
  }
`;
